/**
 * @generated SignedSource<<e79d3375ed90dfde32f5baaad798804b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatButton_Recipient$data = {
  readonly directChatThread: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatButton_ChatThread">;
  } | null | undefined;
  readonly firstName: string | null | undefined;
  readonly id: string;
  readonly self: boolean | null | undefined;
  readonly " $fragmentType": "ChatButton_Recipient";
};
export type ChatButton_Recipient$key = {
  readonly " $data"?: ChatButton_Recipient$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatButton_Recipient">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatButton_Recipient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatThread",
      "kind": "LinkedField",
      "name": "directChatThread",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatButton_ChatThread"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d05a20ec58c30a12ebf5f7fd8dffc4d2";

export default node;
